import { memo } from 'react';
import { Box, CssBaseline, Grid } from '@mui/material';
import PageMainTitle from 'components/cmn/PageMainTitle';
import CustomCard from 'components/cmn/CustomCard';
import AccountProjectListTable from 'components/member-management/AccountProjectListTable';
import { useProject } from 'hooks/useProject';

function UserManagementPage(): JSX.Element {
  const { getAdminAccountProfile } = useProject();
  const { data } = getAdminAccountProfile();
  const id = data?.id || '';

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Grid container>
        <Grid item xs={12} sx={{ mb: 2 }}>
          <PageMainTitle title={`${data?.name}님의 프로젝트 진행상황`} />
          <CustomCard sx={{ mt: 2 }} content={false} border>
            <AccountProjectListTable id={id || ''} type="manager" />
          </CustomCard>
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(UserManagementPage);
